export default "__VITE_ASSET__BQbqgB_S__"